import _classCallCheck from "C:\\Users\\rose\\Documents\\learning\\card-memory-game\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\rose\\Documents\\learning\\card-memory-game\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import isPlainObject from 'is-plain-obj';
import { safeValues } from './Devtools';
import { Derived } from './derived';
export var IS_TEST = process.env.NODE_ENV === 'test';
export var IS_OPERATOR = Symbol('operator');
export var ORIGINAL_ACTIONS = Symbol('origina_actions');
export var EXECUTION = Symbol('execution');
export var MockedEventEmitter =
/*#__PURE__*/
function () {
  function MockedEventEmitter() {
    _classCallCheck(this, MockedEventEmitter);
  }

  _createClass(MockedEventEmitter, [{
    key: "emit",
    value: function emit() {}
  }, {
    key: "emitAsync",
    value: function emitAsync() {}
  }, {
    key: "on",
    value: function on() {}
  }, {
    key: "once",
    value: function once() {}
  }, {
    key: "addListener",
    value: function addListener() {}
  }]);

  return MockedEventEmitter;
}();
export function processState(state, derivedReferences) {
  return Object.keys(state).reduce(function (aggr, key) {
    if (key === '__esModule') {
      return aggr;
    }

    var originalDescriptor = Object.getOwnPropertyDescriptor(state, key);

    if (originalDescriptor && 'get' in originalDescriptor) {
      Object.defineProperty(aggr, key, originalDescriptor);
      return aggr;
    }

    var value = state[key];

    if (isPlainObject(value)) {
      aggr[key] = processState(value, derivedReferences);
    } else if (typeof value === 'function') {
      aggr[key] = new Derived(value);

      if (derivedReferences) {
        derivedReferences.push(aggr[key]);
      }
    } else {
      Object.defineProperty(aggr, key, originalDescriptor);
    }

    return aggr;
  }, {});
}
export function getFunctionName(func) {
  return func.name || func.displayName || '';
}
export var makeStringifySafeMutations = function makeStringifySafeMutations(mutations) {
  return mutations.map(function (mutation) {
    return Object.assign({}, mutation, {
      args: safeValues(mutation.args)
    });
  });
};
export function deepCopy(obj) {
  if (isPlainObject(obj)) {
    return Object.keys(obj).reduce(function (aggr, key) {
      if (key === '__esModule') {
        return aggr;
      }

      var originalDescriptor = Object.getOwnPropertyDescriptor(obj, key);
      var isAGetter = originalDescriptor && 'get' in originalDescriptor;
      var value = obj[key];

      if (isPlainObject(value) && !isAGetter) {
        aggr[key] = deepCopy(value);
      } else {
        Object.defineProperty(aggr, key, originalDescriptor);
      }

      return aggr;
    }, {});
  } else if (Array.isArray(obj)) {
    return obj.map(function (item) {
      return deepCopy(item);
    });
  }

  return obj;
}
export function mergeState(originState, oldState, nextState) {
  function merge(origin, old, next) {
    if (isPlainObject(old) && isPlainObject(next)) {
      var newBranch = {};
      var keys = Object.keys(old).concat(Object.keys(next));
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;
          newBranch[key] = merge(origin[key], old[key], next[key]);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return newBranch;
    }

    if (typeof next === 'function') {
      return next;
    } // We return the existing array, as arrays are typically
    // mutated, not set with new values as initial state


    if (Array.isArray(old) && Array.isArray(next)) {
      return old;
    } // If we have changed a state from origin, keep that
    // changed state


    if (next === origin && old !== origin) {
      return old;
    }

    return next;
  }

  return merge(originState, oldState, nextState);
}
export function getActionPaths() {
  var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var currentPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Object.keys(actions).reduce(function (aggr, key) {
    if (typeof actions[key] === 'function') {
      return aggr.concat(currentPath.concat(key).join('.'));
    }

    return aggr.concat(getActionPaths(actions[key], currentPath.concat(key)));
  }, []);
}
export function createActionsProxy(actions, cb) {
  return new Proxy(actions, {
    get: function get(target, prop) {
      if (prop === ORIGINAL_ACTIONS) {
        return actions;
      }

      if (typeof target[prop] === 'function') {
        return cb(target[prop]);
      }

      if (!target[prop]) {
        throw new Error("You are pointing towards an action that does not exist. \"".concat(String(prop), "\" does not exist"));
      }

      return createActionsProxy(target[prop], cb);
    }
  });
}